<template>
  <section class="choice-taste-collection">
    <div class="choice-taste-collection__container">
      <div class="choice-taste-collection__info choice-taste-collection__info_barista" data-fade-in-bottom>
        <h1 class="choice-taste-collection__title title title_h1">Green milk barista</h1>
        <p class="choice-taste-collection__description description description_p1">
          Чтобы Ваш кофе был идеальным. Green Milk Barista разработан вместе с бариста,
          для профессионального использования.
        </p>
      </div>
      <div class="choice-taste-collection__info choice-taste-collection__info_gm" data-fade-in-bottom>
        <h1 class="choice-taste-collection__title title title_h1">Green milk</h1>
        <p class="choice-taste-collection__description description description_p1">
          Продукт гарантирует наслаждение яркими
          <br>
          и натуральными вкусами с пользой
          <br>
          для организма и без вреда для природы.
        </p>
      </div>
    </div>
    <div class="choice-taste-slider swiper swiper-no-swiping" data-custom-cursor=".custom-cursor">
      <div class="choice-taste-slider__wrapper swiper-wrapper">
        <div v-for="(product, index) in resultProducts" :key="index" class="choice-taste-slider__slide swiper-slide"
             :style="product.PROPERTIES.COLOR.VALUE">
          <div class="choice-taste-slider__background">
            <svg class="i-choice-taste-slide-bg" aria-hidden="true">
              <use xlink:href="./icons/icons.svg#svg-choice-taste-slide-bg"></use>
            </svg>
          </div>
          <p  class="choice-taste-slider__description description-arrow"><span v-html="product.PROPERTIES.DESCRIPTION['~VALUE'].TEXT">
                   </span>
            <svg class="i-arrow-dotted i-arrow-dotted_mirror" aria-hidden="true">
              <use xlink:href="./icons/icons.svg#svg-arrow-dotted"></use>
            </svg>
          </p>
          <div class="choice-taste-slider__packing">
            <picture>
              <img :src="product.PROPERTIES.PRODUCT_IMAGE.SRC" alt="alt">
            </picture>
          </div><a class="choice-taste-slider__link link-taste-more" :href="product.DETAIL_PAGE_URL">
          <svg class="i-btn-bg" aria-hidden="true">
            <use xlink:href="./icons/icons.svg#svg-btn-bg"></use>
          </svg>
          <div class="link-taste-more__wrapper">
            <svg class="i-arrow-curved" aria-hidden="true">
              <use xlink:href="./icons/icons.svg#svg-arrow-curved"></use>
            </svg>
            <div>Подробнее о вкусе</div>
          </div></a>
        </div>

      </div>
      <div class="custom-cursor"></div>
    </div>
  </section>
</template>

<script>
export default {
  name : "CollectionMainPage",

  props: {
    products: {
      type: Array,
      required: true
    },
    theme: {
      type: String,
      required : true
    }
  },

  computed: {
    resultProducts() {
      return this.products.filter(item => item.IBLOCK_GENERAL_SECTION_CODE === this.theme);
    }
  }

};
</script>

<style scoped>

</style>